<bb-payment-card-ui
  [paymentCard]="paymentCard"
  [paymentCardNumberFormat]="numberFormat"
  [displayEmblem]="true"
></bb-payment-card-ui>
